import * as Sentry from '@sentry/react';

import { isProduction } from '@dashboard/services/env';

Sentry.init({
  dsn: 'https://92671e6d5dfd45b59fc375bc1973a7d9@o137724.ingest.us.sentry.io/304726',
  enabled: isProduction,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  /* ignoreErrors: [
    'TypeError: undefined is not a constructor',
    'ChunkLoadError',
    'TypeError: Load failed',
    'TypeError: Failed to fetch',
    'TypeError: cancelled',
    'Non-Error promise rejection captured with value:',
    "Your card's security code is incomplete.",
    'globalThis is not defined',
    'Loading CSS chunk',
    'Importing a module script failed.',
  ],
  beforeSend: event => {
    if (event?.message?.includes("Can't find variable: gmo")) {
      return null;
    }

    return event;
  }, */
});
